import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'somatometry',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'patient-somatometry-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                   
                    {                           
                        transKey: 'breadcrumbs.somatometry-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "index-somatometry" */ '@/modules/patient-profile/somatometry/views/Create.vue')
        }
    ]
}